import type { CurrencyId } from "@/services/currencies";
import { type Purchase } from "@/services/marketplace/order/purchases/purchasesTypes";
import { type Ref } from "vue";

export class InvalidCurrencyCombinationInPurchase extends Error {}

export function assertAllProductsOfSameCurrency(purchase: Purchase): void {
  let currencyId: CurrencyId | undefined = undefined;
  purchase.products.forEach(({ price }) => {
    if (currencyId === undefined) {
      currencyId = price.currencyId;
    } else {
      if (currencyId !== price.currencyId) {
        throw new InvalidCurrencyCombinationInPurchase("Purchase contains products with different currencies!");
      }
    }
  });
}

export function assertFullPurchaseOfSameCurrency(purchase: Purchase): void {
  assertAllProductsOfSameCurrency(purchase);

  const currencyId = purchase.products[0].price.currencyId;

  if (purchase.commissionPrice.currencyId !== currencyId) {
    throw new InvalidCurrencyCombinationInPurchase("Commission price is of different currency than products!");
  }

  if (purchase.payment.method.price.currencyId !== currencyId) {
    throw new InvalidCurrencyCombinationInPurchase("Payment price is of different currency than products!");
  }

  if (purchase.shipping.method.price.currencyId !== currencyId) {
    throw new InvalidCurrencyCombinationInPurchase("Shipping price is of different currency than products!");
  }
}

export function assertPurchaseInjectionIsNotUndefined(purchase: Ref<Purchase | undefined>): asserts purchase is Ref<Purchase> {
  if (purchase.value === undefined) {
    throw new Error("Purchase injection value is undefined.");
  }
}
